import { FC, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/store';
import { fetchProfileIdsEffect } from 'app/store/Profile/effects';
import { LoadingState } from 'types/enums';
import {
  getCurrentProfile,
  getProfileLoadingStateSelector,
} from 'app/store/Profile/selectors';
import { ProfileTopSection } from 'app/components/Profile/ProfileTopSection/ProfileTopSection';
import { getCreateReleaseValidations } from 'app/store/Releases/selectors';
import { fetchCreateReleaseValidationsEffect } from 'app/store/Releases/effects';
import { PageWrapper } from 'app/components/Core';

export const ProfileDesktop: FC = () => {
  const dispatch = useAppDispatch();
  const profileLoadingState = useAppSelector(getProfileLoadingStateSelector);
  const currentProfile = useAppSelector(getCurrentProfile);
  const releaseValidation = useAppSelector(getCreateReleaseValidations);
  const isLoading =
    profileLoadingState === LoadingState.FETCHING || !releaseValidation;

  useEffect(() => {
    dispatch(fetchProfileIdsEffect());
  }, [dispatch]);

  useEffect(() => {
    if (!releaseValidation) {
      dispatch(fetchCreateReleaseValidationsEffect());
    }
  }, [dispatch, releaseValidation]);

  return (
    <PageWrapper
      pt={0}
      px={0}
      height="auto"
      overflow="initial"
      flex={1}
      flexShrink={0}
      flexBasis="auto"
    >
      <ProfileTopSection
        currentProfile={currentProfile}
        isLoading={isLoading}
      />
      <Outlet />
    </PageWrapper>
  );
};
